import React from 'react';
import PropTypes from 'prop-types';
import useGetCountryFromUrl from '../../hooks/useGetCountryFromUrl';
import { MoneyType } from '../../propTypes';
import AmountWithIvaCell from './AmountWithIvaCell';
import AmountToCollectWithDebt from './AmountToCollectWithDebt';
import InvoiceWithDebtAmount from './InvoiceWithDebtAmount';

const AmountToCommercialCollectCell = ({ row }) => {
  const country = useGetCountryFromUrl();
  const countryToComponent = {
    Chile: InvoiceWithDebtAmount,
    Mexico: AmountToCollectWithDebt,
  };

  const CountryComponent = countryToComponent[country?.name] || AmountWithIvaCell;
  return (
    <CountryComponent row={row} />
  );
};

AmountToCommercialCollectCell.propTypes = {
  row: PropTypes.shape({
    amountWithIva: PropTypes.number,
    invoiceDebt: PropTypes.shape({
      debt: PropTypes.number,
    }),
    retentionRate: PropTypes.number,
    creditNotes: PropTypes.arrayOf(PropTypes.shape({
      amountWithIva: MoneyType.isRequired,
      id: PropTypes.string.isRequired,
    })),
    debitNotes: PropTypes.arrayOf(PropTypes.shape({
      amountWithIva: MoneyType.isRequired,
      id: PropTypes.string.isRequired,
    })),
  }),

};

AmountToCommercialCollectCell.defaultProps = {
  row: {
    amountWithIva: 0,
    invoiceDebt: {
      debt: 0,
    },
    offer: {
      retentionRate: 0,
    },
    creditNotes: [],
    debitNotes: [],
  },
};

export default AmountToCommercialCollectCell;
